<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-06-16 16:34:24
 * @Description: 围栏报警
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="h-100">
    <el-table :data="fenceWarningList" v-loading="fenceWarningLoading" class="h-100">
      <el-table-column type="index" label="序号" width="55" align="center">
        <template slot-scope="scope">
          <span>{{ (page.currentPage - 1) * page.size + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        v-for="col in columns"
        :prop="col.prop"
        :key="col.prop"
        :label="col.label"
        :width="col.width"
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="getUntreatedWarningList"
      @current-change="getUntreatedWarningList"
      :page-size.sync="page.size"
      :current-page.sync="page.currentPage"
      :page-sizes="$pageSizeAll"
      layout="sizes,jumper"
      class="r m-t-5"
    ></el-pagination>
  </div>
</template>
<script>
import LocalSense from '@/services/baoChang/localSense'

export default {
  data() {
    return {
      fenceWarningLoading: false,
      fenceWarningList: [],
      page: {
        size: 15,
        total: 10,
        currentPage: 1,
      },
      warningTypeList: [],
      searchDateRange: [moment().subtract(7, 'days'), moment()], // 查询时间段
      columns: [
        {
          prop: 'alarmmer',
          label: '对象名称',
        },
        {
          prop: 'warningType',
          label: '告警类型',
        },
        {
          prop: 'warningTime',
          label: '告警时间',
          width: '150px',
        },
        {
          prop: 'content',
          label: '告警信息',
          width: '150px',
        },
        {
          prop: 'handler',
          label: '处理人',
        },
        {
          prop: 'handleTime',
          label: '处理时间',
        },
        {
          prop: 'handleStatus',
          label: '处理状态',
        },
      ],
    }
  },
  async created() {
    await this.getWarningTypeList()
    this.getUntreatedWarningList()
  },
  methods: {
    // 获取告警类型列表
    async getWarningTypeList() {
      const res = await LocalSense.getWarningTypeList()
      if (res && res.code === 0 && res.data && res.data.rows) {
        this.warningTypeList = _.filter(res.data.rows, (item) => {
          return item.recordtype !== '0'
        })
      }
    },
    // 获取未处理的告警信息列表
    async getUntreatedWarningList() {
      this.fenceWarningLoading = true
      this.fenceWarningList = []
      const res = await LocalSense.getUntreatedWarningList({
        getTimes: this.page.currentPage,
        lineNum: this.page.size,
        currentLoginUsername: currentEnv.VUE_APP_SENSE_SERVER.username,
        beginTime:
          this.searchDateRange && this.searchDateRange[0]
            ? moment(this.searchDateRange[0]).valueOf()
            : moment()
                .subtract(7, 'days')
                .valueOf(),
        endTime:
          this.searchDateRange && this.searchDateRange[1]
            ? moment(this.searchDateRange[1]).valueOf()
            : moment().valueOf(),
      })
      this.fenceWarningLoading = false
      if (res && res.code === 0 && res.data && res.data.rows) {
        this.fenceWarningList = _.map(res.data.rows, (item) => {
          return {
            id: item.id,
            alarmmer: item.alarmmer,
            tagId: item.related_tagid,
            type: item.type,
            warningType:
              _.find(this.warningTypeList, ['recordtype', _.toString(item.type)]).alarmshow || '',
            warningTime: moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss'),
            content: item.content,
            handler: '-',
            handleTime: '-',
            handleStatus: '未处理',
            handleWay: '-',
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>

/deep/ .el-table {
  background: #ffffff61 !important;
  thead th {
    padding: 0px;
    background: none !important;
  }
  &__body-wrapper {
    background: none !important;
    height: calc(100% - 25px);
    overflow-y: scroll;
  }
  &__empty-block {
    background: none !important;
  }
  &__expanded-cell {
    background: #ffffff40 !important;
    padding: 0px 10px;
    padding-left: 20px;
  }
}

</style>
